import React from 'react';
import './LoadingSpinner.scss';
import { Typography } from '@material-ui/core';

export const LoadingSpinner = () => 
  <Typography variant='caption'>
    Loading...
  </Typography>